/* @flow */

import formSerialize from 'form-serialize';
import {
    NIVEL_MASTER,
    NIVEL_SUPORTE,
    NIVEL_ADMIN,
    NIVEL_FUNCIONARIO,
} from '../usuario/constants';
import { type Nivel } from '../usuario/types';
import { type BodyLogin } from './types';
import applyLoading from '../utils/apply-loading';
import isAdmin from './is-admin';

const getNiveis = (): Nivel[] => (
    isAdmin()
        ? [NIVEL_MASTER, NIVEL_SUPORTE]
        : [NIVEL_ADMIN, NIVEL_FUNCIONARIO]
);

const getParametros = (form: HTMLElement): BodyLogin => {
    const dadosFormulario = formSerialize(form, { hash: true });

    return {
        ...dadosFormulario,
        nivel: getNiveis(),
    };
};

const entrar = applyLoading(
    (param: BodyLogin) => import('./entrar').then(m => m.default(param)),
    {
        hide: global.mApp.unblockPage,
        show: global.mApp.blockPage,
    },
);

const setEventoFormLogin = (form: HTMLElement) => {
    form.onsubmit = (e) => {
        e.preventDefault();
        entrar(getParametros(form));
        return false;
    };
};

export default setEventoFormLogin;
